import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 20"
}
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<ellipse cx=\"8.752\" cy=\"4.631\" stroke=\"currentColor\" stroke-width=\"1.118\" rx=\"5.638\" ry=\"2.168\"></ellipse><path stroke=\"currentColor\" stroke-linecap=\"round\" stroke-width=\"1.118\" d=\"M10.495 10.61v5.476c0 .707 1.481 1.28 3.31 1.28 1.827 0 3.309-.573 3.309-1.28V10.61M8.752 16.138c-3.114 0-5.638-.971-5.638-2.169V4.684m11.276 0v2.762\"></path><path stroke=\"currentColor\" stroke-linecap=\"round\" stroke-width=\"1.118\" d=\"M17.114 13.347c0 .706-1.482 1.279-3.31 1.279s-3.31-.573-3.31-1.28M8.752 11.496c-3.114 0-5.638-.971-5.638-2.169\"></path><ellipse cx=\"13.804\" cy=\"10.58\" stroke=\"currentColor\" stroke-width=\"1.118\" rx=\"3.309\" ry=\"1.279\"></ellipse><ellipse cx=\"13.804\" cy=\"10.58\" stroke=\"currentColor\" stroke-width=\"1.118\" rx=\"3.309\" ry=\"1.279\"></ellipse>", 5)
const _hoisted_7 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_7]))
}
export default { render: render }